<template>
    <div class='container-jobs' v-bind:class="{'alert-orange-old-jobs row' : workerHasOldJobs }">
        <div id="workerInterface" v-cloak>

        <Alerts v-bind:user="user"></Alerts>
        <AlertMissedJobs></AlertMissedJobs>

        <TutorialsReminder v-bind:user="user" v-if="user.workerIsNovice !== true"></TutorialsReminder>
        <AvailabilitiesReminderMessage></AvailabilitiesReminderMessage>


        <div class="alert alert-green-flat" v-if="user.workerIsNovice === true">
            <span class="fa fa-warning"></span>
            {{"This job is free. Nothing will be charged, we only ask that the customer be satisfied. It's your turn to play!"|trans }}
        </div>

        <div class="alert alert-danger text-center" v-if="error_server.show">
            <strong>{{error_server.message}}</strong><br>
            <strong>{{error_server.message_server}}</strong>
        </div>

        <div v-else>

            <div v-if="user.isLoggedIn">
                <button class="full-width refresh-btn" v-if="!waitingForJobs" v-on:click="getJobs()">
                    <span class="fa fa-refresh"></span>
                </button>

                <div v-if="isIosButNotSafari">
                    <h4 class="text-center">
                        {{'Please use Safari app to use this website'|trans}}
                    </h4>
                </div>

                <div v-else>

                    <p v-if="offline">You appear to be offline...</p>

                    <div class="data-no-sync" v-if="!syncData.isLocalStorageSync && !synchronising">
                        <div class="col-xs-8 text-no-sync">
                            {{'Update at '|trans}} {{ syncData.lastSyncDate }}
                            <span v-if="!navigatorOnline">
                            {{'Connect to internet to synchronize'|trans}}
                        </span>
                        </div>
                        <div class="col-xs-4 text-center">
                            <div v-if="navigatorOnline">
                                <button class="btn btn-sm btn-primary" v-on:click="synchronizeJobs"> Update</button>
                            </div>
                            <span v-if="!navigatorOnline">
                                <br>
                                <i class="fa fa-exclamation-triangle fa-2x"></i>
                            </span>
                        </div>
                    </div>

                    <div class="synchronising" v-if="synchronising">
                        <i class="fa fa-spinner fa-1x fa-spin "></i>
                    </div>


                    <Spinner v-if="waitingForJobs" v-bind:title="'Loading Jobs ...'"></Spinner>


                    <template>
                        <div id="job-worker-list">
                            <div v-if="hasJobsWaitingForQuotation">

                                <!-- ***************************
                                        FOR QUOTATION JOBS
                                ******************************** -->

                                <template v-if="hasJobsWaitingForQuotation || !waitingForJobs">
                                    <div class="alert alert-info text-center message-job-waiting"
                                         v-show="!waitingForJobs && hasJobsWaitingForQuotation">
                                        <strong>{{'Jobs Waiting for quotation'|trans}}</strong>
                                    </div><br>

                                    <template v-for="(jobQuote, jobIndex) in jobs_with_quotation">
                                        <div class="job-waiting-for-quotation">
                                            <Quote
                                                 v-bind:key="jobQuote.id"
                                                 v-bind:quote="jobQuote"
                                                 v-bind:user="user"
                                                 v-on:get_jobs="getJobs"
                                            >
                                            </Quote>
                                        </div>
                                    </template>
                                </template>
                            </div>

                            <div v-if="!hasJobs && !waitingForJobs">
                                <div class="alert alert-success text-center">
                                    <strong>{{'There\'s no job'|trans}}</strong>
                                </div>
                            </div>

                            <div v-if="hasNewJobs || hasOldJobs " >
                                <!-- ***************************
                                        FOR OLD AND NEW JOBS
                                ******************************** -->



                                <div class="alert alert-important text-center"
                                     v-if="hasOldJobs && !waitingForJobs" >
                                    <strong>{{'Encode those jobs to be able to continue'|trans}}</strong>
                                </div>


                                <template v-for="(job, jobIndex) in jobs">
                                    <div class="row">
                                        <div v-if="dateIsVisible(jobIndex)">
                                            <div class="text-center bg-blue date-for-jobs">
                                                <h4 class="dateTitle">{{job.dateJobStart|Date('dddd D MMMM')}}</h4>
                                            </div>
                                        </div>
                                    </div>

                                    <Job v-bind:key="job.id"
                                         v-bind:job="job"
                                         v-bind:totalJobs="totalJobs"
                                         v-bind:editable="isJobEditable(jobIndex)"
                                         v-bind:bankAccountInformation="bank_account_information"
                                         v-bind:user="user"
                                         v-on:completed="job.isCompleted = true"
                                         v-on:step_changed="synchronizeJobs"
                                         v-on:get_jobs="getJobs"
                                         v-on:closeAllJobs="closeAllJobs"
                                         v-if="showLimitOfJobsIfIsNovice(jobIndex)"
                                    >
                                    </Job>

                                </template>
                            </div>


                            <div v-if="user.workerIsNovice === true && user.isSubscriptionPromoteShown && totalJobs > 5" class="alert alert-sell-to-novice text-center ">
                                <img v-bind:src="$absoluteAssetPath('pelican_with_gradient.png')" alt="pelican job" width="100">
                                <div v-if="isMessageAskingForInfoSubscriptionSent===false">
                                    <p>
                                        <strong>{{'You can also switch to paid mode en get much more jobs (from 10€/job)'|trans({currency:$currency.symbol(user.country)})}}</strong>
                                    </p>
                                    <button class="btn-ask-info-subscription" @click="alertWebmasterOfPossibleSubscriptionAndHideMessage">{{'Learn more'|trans}}</button>
                                    <br>
                                    <Spinner v-if="isMessageAskingForInfoSubscriptionSending" v-bind:title="'Sending message please wait ...'|trans"></Spinner>
                                </div>
                                <div v-else>
                                    <div class="alert alert-success">
                                        <strong>{{'Our manager will contact you soon to explain our concept'|trans}}</strong>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </template>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>

    import AvailabilitiesReminderMessage from './Availabilities/AvailabilitiesReminderMessage';
    import Routing from '../backend-router';
    import axios from 'axios';
    import Job from './Job/Job';
    import TutorialsReminder from './Tutorials/TutorialsReminder';
    import Spinner from './Spinner';
    import debounce from 'lodash.debounce';
    import {normalizeJob} from '../modules/jobNormalizer';
    import {normalizeQuotation} from '../modules/quotationNormalizer';
    import localforage from 'localforage';
    import moment from 'moment-timezone';
    import Quote from './Quote';
	import AlertMissedJobs from "./MissedJobs/AlertMissedJobs";
	import Alerts from './WorkerAlerts/Alerts';



    export default {
    	name:"Jobs",
        props: {
            user: Object
        },
        data() {
            return {
                isMessageAskingForInfoSubscriptionSending:false,
                isMessageAskingForInfoSubscriptionSent:false,
                limitOfShownJobsForNovice:5,
                lastJobCompleted: null,
                jobs: [],
                jobs_with_quotation: [],
                waitingForJobs: true,
                offline: false,
                navigatorOnline: navigator.onLine,
                intervalSync: 1000 * 10,
                lastCancelTokenSource: null,
                browserAcceptOfflineMode: false,
                synchronising: false,
                hasJobs: false,
                hasOldJobs: false,
                hasNewJobs: false,
                hasJobsWaitingForQuotation: false,
                jobs_qtt: 0,
                timeoutRequest: 10000,
                isUserLoggedIn: true,
                totalJobs:0,
                syncData: {
                    isLocalStorageSync: true,
                    lastSyncDate: null
                },
                error_server: {
                    message: '',
                    show: false,
                    message_server: '',
                },
                bankAccountInformation: null,
            }
        },
        async created() {

            // register listeners to connection status change
            window.addEventListener('online', this.updateConnectionStatus);
            window.addEventListener('offline', this.updateConnectionStatus);

            await this.isLocalStorageSynchronized();

            try {

                if (this.syncData.isLocalStorageSync === true) {
                    this.getJobs();
                } else {
                    this.jobs = await this.getJobsLocally();
                    this.waitingForJobs = false;
                }
            }
            catch (error) {
                this.offline = false;
                this.waitingForJobs = false;
                this.jobs = await this.getJobsLocally();
            }
        },
        destroyed() {
            // unregister listeners to connection status change
            window.removeEventListener('online', this.updateConnectionStatus);
            window.removeEventListener('offline', this.updateConnectionStatus);
        },
        methods: {
            async getJobs() {

                const lastJobCompleted = this.lastJobCompleted;
                this.waitingForJobs = true;
                try {

                    this.jobs = [];
                    this.jobs_with_quotation = [];
                    const responseData = await this.$api.job.getJobs();

                    this.hasJobs = responseData.has_jobs;
                    this.hasOldJobs = responseData.has_old_jobs;
                    this.hasNewJobs = responseData.has_new_jobs;
                    this.jobs_qtt = responseData.jobs_qtt;
                    this.totalJobs = responseData.total_jobs;
                    this.bank_account_information = responseData.bank_account_information;



                    if (this.hasJobs) {
                        this.jobs = responseData.jobs.map(normalizeJob);
                        for (const job of this.jobs) {
                            if (lastJobCompleted !== undefined && lastJobCompleted !== null) {
                                if (lastJobCompleted.workerIntervention.job_id === job.workerIntervention.job_id) {
                                    job.workerIntervention.isOpenJob = true;
                                }
                            }
                            if(job.isWorkerTheOwner){ // force before creating object on database
								job.workerIntervention.pureContact.discloseAccepted = true;
                            }
                        }
                    }

                    /****
                     * Quotation Pending
                     **/
                    this.hasJobsWaitingForQuotation = responseData.has_jobs_waiting_for_quotation;

                    if (this.hasJobsWaitingForQuotation) {
                        this.jobs_with_quotation = responseData.jobs_with_quotation.map(normalizeQuotation);
                    }

                    await  this.setLocalStorage('worker_jobs', this.jobs);
                    this.waitingForJobs = false; // when Request finished

                } catch (error) {

                    this.error_server.show = true;
                    this.error_server.message = error.message;
                    // If cannot get jobs keep using localjobs
                    const tmpJobs = await this.getJobsLocally();

                    if (tmpJobs !== null && tmpJobs.length > 0) {
                        this.jobs_qtt = tmpJobs.length;
                        this.jobs = tmpJobs;
                    }
                    this.waitingForJobs = false;

                    if (this.$api.is401(error)) {
                        // in case of 401, just abort javascript execution
                        return;
                    }
                    if (this.$api.isCancel(error)) {
                        // request canceled programmatically, let the new request do the job
                        return;
                    }
                    if (this.$api.isNoConnectivity(error)) {
                        this.error_server.error_message = this.$options.filters.trans('No connection ?');
                    } else {
                        this.$bugsnagClient.notify(error);
                        this.errorMessage = this.$options.filters.trans('Unknown error');
                    }

                }
            },
            async getJobsLocally() {

                const localJobs = await this.getLocalStorage('worker_jobs');

                if (localJobs === null || this.isObjectEmpty(localJobs)) {
                    this.syncData.isLocalStorageSync = true;
                    this.setIsLocalStorageSync();
                }

                if (this.isObjectEmpty(localJobs) === false) {
                    this.jobs_qtt = localJobs.length;
                }

                return localJobs;

            },
            async getLocalStorage(key) {
                return await localforage.getItem(key);
            },
            async isLocalStorageSynchronized() { // Check if the last data has been mustGetJobs
                const isLocalStorageSync = await this.getLocalStorage('isLocalStorageSync');
                if (isLocalStorageSync !== null) {
                    this.syncData = isLocalStorageSync;
                } else {
                    this.syncData.isLocalStorageSync = true;
                }
            },
            async synchronizeJobs(isCompleted) {

                const workerInterventionsEdited = this.jobs === null
                    ? null
                    : this.jobs
                        .filter(job => {
                            return job.workerIntervention !== null && job.workerIntervention.is_job_edited;
                        })
                        .map(job => {
                            const workerIntervention = job.workerIntervention;
                            workerIntervention.job_id = job.id;
                            return workerIntervention;
                        });


                try {
                    this.synchronising = true;
                    const dataSynchronizedJobs =  await this.$api.worker.synchronizeJobs(workerInterventionsEdited);
                    this.checkIfJobHasBeenUpdatedAndRefresh(dataSynchronizedJobs.synchronised_jobs);
                    this.synchronising = false;
                    this.syncData.lastSyncDate = moment().format('YYYY-MM-D hh:mm:ss');
                    this.syncData.isLocalStorageSync = true;
                }
                catch (error) {

                    if (this.$api.isCancel(error)) {
                        return;
                    }

                    this.syncData.isLocalStorageSync = false;
                }

                this.synchronising = false;

                this.setIsLocalStorageSync();

                if (isCompleted && this.syncData.isLocalStorageSync) { // Reload Jobs Web Is Completed
                    /** TODO  ADRIAN After get jobs vue dont change the data loaded via ajax **/
                    this.getJobs(); // check also when offline;
                }
            },
            async updateConnectionStatus() {
                this.navigatorOnline = navigator.onLine;
                if (this.navigatorOnline) {
                    await this.synchronizeJobs();
                    await this.getJobs();
                }
            },
            async setLocalStorage(key, data) {
                try{
                    localforage.setItem(key, data);
                }
                catch (error) {
                    let customReport = {};
                    customReport.message = 'Error of localforage';
                    customReport.sizeOfLocalStorage = await this.getSizeOfLocalStorage();
                    this.$bugsnagClient.notify(error, {
                        beforeSend: function (report) {
                            report.metaData = {
                                localStorage: customReport
                            };
                        }
                    })
                }
            },
              async getSizeOfLocalStorage() {
                  if ('storage' in navigator && 'estimate' in navigator.storage) {
                      let storageInfo = await navigator.storage.estimate();
                      storageInfo.quota = this.readableBytes(storageInfo.quota);
                      storageInfo.usage = this.readableBytes(storageInfo.usage);
                      storageInfo.usageDetails.indexedDB = this.readableBytes(storageInfo.usageDetails.indexedDB);
                      return storageInfo;
                  }
                  return null;
            },
            readableBytes(bytes) {
                var i = Math.floor(Math.log(bytes) / Math.log(1024)),
                    sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + sizes[i];
            },
            async setIsLocalStorageSync() {
                await this.setLocalStorage('isLocalStorageSync', {
                    'isLocalStorageSync': this.syncData.isLocalStorageSync,
                    'lastSyncDate': this.syncData.lastSyncDate
                });
            },
            isObjectEmpty(obj) {
                for (var key in obj) {
                    if (obj.hasOwnProperty(key))
                        return false;
                }
                return true;
            },
            dateIsVisible(jobIndex) {
                return jobIndex === 0 || !moment(this.jobs[jobIndex].dateJobStart.date).isSame(this.jobs[jobIndex - 1].dateJobStart.date, 'days');
            },
            isJobEditable(jobIndex) {
                if (jobIndex === 0 || this.jobs[jobIndex - 1].isCompleted) {
                    return true;
                }
                return false;
            },
            setJobsLocally: debounce(function () {
                this.setLocalStorage('worker_jobs', this.jobs);
            }, 800),
            closeAllJobs(currentTriggeredJob) {
                if(this.hasJobs){
                    this.jobs.forEach(function (job) {
                        if (currentTriggeredJob.id !== job.id) {
                            job.workerIntervention.isOpenJob = false;
                        }
                    });
                }
            },
            checkIfJobHasBeenUpdatedAndRefresh(synchronisedJobs){
                Object.entries(synchronisedJobs).forEach(([jobIdKey,value])=>{
                    if(value.is_updated === false){
                        this.getJobs();
                    }
                });
            },
            showLimitOfJobsIfIsNovice(index){
                if(this.user.workerIsNovice === true){
                    return (index <= this.limitOfShownJobsForNovice -1);
                }
                return true;
            },
            async alertWebmasterOfPossibleSubscriptionAndHideMessage(){
                this.isMessageAskingForInfoSubscriptionSending = true;
                await this.$api.worker.alertWebmasterAndHidePromotedMessage();
                this.isMessageAskingForInfoSubscriptionSent = true;
                this.isMessageAskingForInfoSubscriptionSending = false;
                setTimeout(() =>{
                    this.user.isSubscriptionPromoteShown = false;
                }, 1000*4);

            }
        },
        watch: {
            jobs: {
                handler: function () {
                    this.setJobsLocally();
                },
                deep: true,
            }
        },
        filters: {
            Date(date, format) {
                return moment(date.date).format(format);
            }
        },
        computed: {
            workerHasOldJobs(){
                return this.hasOldJobs && !this.waitingForJobs ? true : false;
            },
            isIosButNotSafari() {
                const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                const ua = navigator.userAgent.toLowerCase();
                let isSafari = false;
                if (ua.indexOf('safari') != -1) {
                    isSafari = true;
                }
                return iOS && !isSafari;
            }
        },
        components: {
			AlertMissedJobs,
			Alerts,
            Job,
            AvailabilitiesReminderMessage,
            TutorialsReminder,
            Spinner,
            Quote
        }
    }
</script>

<style lang="scss">
    #workerInterface {
        margin-top: 0px;
    }

    .data-no-sync {
        position: fixed;
        bottom: 0px;
        left: 0px;
        background-color: red;
        z-index: 999999;
        padding: 5px;
        width: 100%;
        color: white;
    }

    [v-cloak] {
        display: none;
    }

    @-webkit-keyframes sk-bouncedelay {
        0%, 80%, 100% {
            -webkit-transform: scale(0)
        }
        40% {
            -webkit-transform: scale(1.0)
        }
    }

    @keyframes sk-bouncedelay {
        0%, 80%, 100% {
            -webkit-transform: scale(0);
            transform: scale(0);
        }
        40% {
            -webkit-transform: scale(1.0);
            transform: scale(1.0);
        }
    }


    .fade-enter {
        left: 400px;
        position: relative;
        opacity: 0;
    }

    .fade-enter-active {
        transition: opacity .5s, left .3s;
        position: relative;
    }

    .fade-enter-to {
        left: 0;
        position: relative;
    }

    .fade-leave {
        display: none;
    }

    .fademessage-enter {
        opacity: 0;
    }

    .fademessage-enter-active {
        transition: opacity .3s;
    }

    .fademessage-enter-to {
        opacity: 1;
    }

    .fademessage-leave {
        opacity: 1;
    }

    .fademessage-leave-active {
        transition: opacity .3s;
    }

    .fademessage-leave-to {
        opacity: 0;
    }

    .confirmationMessage {
        background-color: limegreen;
        color: white;
        position: fixed !important;
        top: 0;
        width: 100%;
        padding: 14px;
        z-index: 999999;
        text-align: center;
        font-weight: bold;
        border: 2px solid #2caf2c;
        margin: 0px;
        left: 0px;
    }

    .errorConnectionMessage,
    .errorMessage {
        background-color: red;
        color: white;
        position: fixed !important;
        top: 0;
        width: 100%;
        padding: 14px;
        z-index: 999999;
        text-align: center;
        font-weight: bold;
        border: 2px solid #ff4014;
        margin: 0px;
    }

    .errorConnectionMessage .btn-login {
        background-color: white;
        color: black;
        padding: 4px;
        width: 100%;
    }

    #job-worker-list .btns-call button {
        width: 48%;
        margin: 1%;
    }

    #job-worker-list .content-description {

        padding: 10px;
    }

    #job-worker-list .job-description {
        padding: 5px;
        border-radius: 2px;
    }

    #job-worker-list .job-block {
        margin-bottom: 20px;
    }

    #job-worker-list .card-header {
        padding: 10px 10px;
        background-color: #4890DB;
        color: white;
        border-bottom: 0px;
    }

    #job-worker-list .card-header .title {
        font-size: 20px;
        font-weight: bold;
        color: white;
    }

    #job-worker-list .card-body {
        padding: 0px !important;
    }

    #job-worker-list .btns-job .btn {
        margin: 2px;
    }

    #job-worker-list label {
        font-size: 12px !important;
    }

    #job-worker-list .block-form {
        background-color: #deecc6;
        margin-top: 5px;
        padding: 10px;
    }

    #job-worker-list .five-fields {

    }

    #job-worker-list .five-fields .field {
        width: 18%;
        margin: 1%;
        display: inline-block;
    }

    #job-worker-list .five-fields .form-control {
        padding: 4px 0px 4px 4px !important;
    }

    #job-worker-list .block-form .spacer-form {
        padding: 0px 4px !important;
        margin: 0px !important;
    }

    #job-worker-list .generate-devis {
        background-color: #cde4c8;
    }

    #job-worker-list .card {
        margin-bottom: 20px;
    }

    #job-worker-list .option-job {
        padding-top: 10px;
    }

    #job-worker-list .card {
        border: 1px solid #1983d0;
        border-bottom: 1px solid #1983d0;
    }



    #job-worker-list .row > [class*="col-"] {
        //margin-bottom: 5px !important;
    }

    #job-worker-list .no-margin-bottom {
        margin-bottom: 0px !important;
    }

    #job-worker-list .back-btn {
        background-color: #e5e5e5;
        font-size: 18px;
        color: black;
    }

    #job-worker-list .quizz button.small-btn-close-input {
        min-height: 34px !important;
    }

    #job-worker-list .quizz .conditions {
        background-color: white;
        padding: 10px;
        text-align: left;
        font-size: 10px;
    }

    #job-worker-list .quizz .signature {
        background-color: white;
        border: 2px dotted #c7c7c7;
        padding: 10px;
        border-radius: 4px;
        height: 250px;
    }

    #job-worker-list .quizz button {
        border-radius: 4px;
        min-height: 60px;
        width: 100%;
    }

    #job-worker-list .quizz a.btn {
        border-radius: 4px;
        padding: 18px;
    }

    #job-worker-list .back-row button {
        min-height: 36px;
    }

    #job-worker-list .menu-last-quizz button:hover {
        background-color: #637485;
    }

    #job-worker-list .click-to-sign {
        text-align: center;
        color: #b9b9b9;
    }

    #job-worker-list .click-to-sign h4 {
        margin-top: 27%;
    }

    #job-worker-list .btn-thanks {
        text-align: center;
        width: 100% !important;
        display: inline-block;
        padding: 10px 20px;
        margin-top: 5px;
        font-size: 28px;
        color: #00906a;
        background-color: #c0cbda;
    }

    #job-worker-list .quizz {
        border-radius: 4px;
        background-color: #c8d4e0;
        position: relative;
        left: 0;
        z-index: 000009;
        margin-top: 10px;
        padding: 10px 5px;
        border: solid 1px #757575;
        box-shadow: 0px 0px 10px -1px #000000;
    }

    #job-worker-list .card .card-body {
        position: relative;
    }

    #job-worker-list .translucent {
        position: fixed;
        top: 0;
        left: 0;
        background-color: white;
        opacity: 0.9;
        -moz-opacity: 0.5;
        filter: alpha(opacity=50);
        width: 100%;
        height: 100%;
        z-index: 000008;
    }

    #job-worker-list .extraHeight {
        height: 300px;
    }

    .fixedDiv {
        position: fixed !important;
        top: 0px;
        left: 0px;
        height: 100%;
        overflow-y: scroll;
        padding-bottom: 60px !important;
        z-index: 333333 !important;
    }

    #job-worker-list .menu-last-quizz {
        padding: 10px;
    }

    #job-worker-list .menu-last-quizz .col-xs-3 {
        padding: 0px 5px;
    }

    #job-worker-list .percent_worker {
        background-color: #9de22d;
    }

    .synchronising {
        background-color: #78ff20;
        color: black;
        bottom: 0px;
        right: 0px;
        padding: 10px;
        position: fixed;
        z-index: 222223;
    }

    .text-no-sync {
        padding-top: 10px;
    }

    .conditions-scroll {
        max-height: 120px;
        overflow: scroll;
        font-size: 14px;
        padding: 12px 15px;
    }

    .conditions-scroll .ui-state-highlight, .tab-content > div {
        padding: 5px !important;
    }

    .alert-important {
        background-color: #f54427;
        color: white;
    }

    .alert-info {
        //background-color: #f54427 !important;
        //color: white !important;
    }

    .tag-danger {
        background-color: #f54427 !important;
    }

    .startQuizz {
        border-radius: 0px !important;
        border: 0px !important;
        box-shadow: none !important;
        padding: 0px !important;
        margin: 0px !important;
    }

    .job-waiting-for-quotation .card {
        border: 1px solid #bfbfbf !important;
    }

    .job-waiting-for-quotation .card .card-header {
        background-color: #d9d9d9 !important;
    }

    .bg-blue {
        background: #2e333b;
    }

    .date-for-jobs {
        color: white;
        padding: 10px;
        margin-bottom: 10px;
        text-transform: uppercase;
        font-weight: bold;
    }

    .message-job-waiting {
        margin-bottom: 0px !important;
    }

    .refresh-btn {
        background-color: inherit;
        border: none;
        font-size: 20px;
        margin: 0px 0px 10px 0px !important;
        color: #1e9dee;
    }

    .alert-info-in-red{
        background-color:#e8463d;
        color:white;
    }

    .alert-orange-old-jobs{
        background-color: #ffa75b;
    }

    .alert-sell-to-novice{
        border:2px solid #8015c3;
        background: #9e33e2;
        color:white;
    }

    .alert-sell-to-novice .btn-ask-info-subscription{
        border-radius: 4px;
        background:#f5e6f8;
        color:#7c117c;
        padding:10px 20px;
        font-size:18px;
        width: 70%;
        min-width: 200px;
        max-width: 400px;
        font-weight: bold;
    }

    .container-jobs{
       /*padding:10px;*/
    }
    .exposeBouton{
      margin:0px;
    }

</style>


